// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hidden {\n display: none;\n}\n.new_design {\n padding: 35px 60px;\n}\n.new_design_color {\n background-color: #ececec;\n padding: 35px;\n}\n::v-deep.v-text-field--outlined > .v-input__control > .v-input__slot {\n background: #ffff !important;\n}\n", ""]);
// Exports
module.exports = exports;
